/* global Sys, Core, Resources, Services, Language, Utils */
Sys.ns("Core");

/**
 * The Error Manager model.
 *
 * @class Core.ErrorManagerModel
 * @extends Core.Model
 */
Core.ErrorManagerModel = {

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.ErrorManagerModel.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    setupData: function() {
        var queryData = Resources.readData("queryData"),
            depositAvailable = Sys.isDefined(queryData.depositAvailable) && queryData.depositAvailable === true;

        this.storeData("depositAvailable", depositAvailable);
        this.storeData("dialogConfig", this.setupDialogConfig(depositAvailable));
    },

    /**
     * Creates config objects for all error dialogs shown by the error manager.
     *
     * @param {boolean} depositAvailable Some messages depend on whether or not the player has the option to deposit more money.
     * @returns {Object} The dialog config for all the game errors.
     */
    setupDialogConfig: function(depositAvailable) {
        var dialogConfig = {},
            reload = { type: "reload", primary: true },
            depositOrHomeButton = depositAvailable ? [{ type: "reduceBetAndRevertSpin" }, { type: "deposit", primary: true }] : [{ type: "casino" }, { type: "reduceBetAndRevertSpin", primary: true }],
            isHomeAvailable = Sys.utils.isHomeAvailable();

        dialogConfig.http = {
            title: Services.languageManager.getText(Language.Keys.connectionLost),
            text: Services.languageManager.getText(Language.Keys.reload),
            buttons: isHomeAvailable ? [{ type: "casino", reason: Utils.CONSTANTS.REASON_CODES.TECHNICAL_ERROR }, reload] : [reload],
            fatal: true
        };

        dialogConfig[11] = {
            title: Services.languageManager.getText(Language.Keys.playLimit),
            text: Services.languageManager.getText("11"),
            buttons: isHomeAvailable ? [{ type: "casino", reason: Utils.CONSTANTS.REASON_CODES.ACKNOWLEDGES_PLAYER_LIMIT, primary: true }] : []
        };

        dialogConfig[12] = {
            title: Services.languageManager.getText(Language.Keys.freeRounds_expired),
            buttons: isHomeAvailable ? [{ type: "casino", primary: true }] : [reload],
            fatal: true
        };

        dialogConfig[13] = {
            title: Services.languageManager.getText(Language.Keys.playLimit),
            text: Services.languageManager.getText("13"),
            buttons: [{ type: "closeAndRevertSpin" }, { type: "reduceBetAndRevertSpin", primary: true }]
        };

        // need to check Language.Keys.freeRoundsOfferUsed not available
        Sys.each([14, 16], function(errorCode) {
            dialogConfig[errorCode] = {
                text: Services.languageManager.getText(Language.Keys.freeRoundsOfferUsed),
                buttons: [{ type: "closeBonusProgramWidget", primary: true }]
            };
        });

        dialogConfig[20] = {
            title: Services.languageManager.getText(Language.Keys.sessionTimeOut),
            text: Services.languageManager.getText(isHomeAvailable ? Language.Keys.returnToLobby : "20"),
            buttons: isHomeAvailable ? [{ type: "casino", reason: Utils.CONSTANTS.REASON_CODES.SESSION_TIMEOUT, primary: true }] : [],
            fatal: true
        };

        Sys.each([10, 15, 51, 100, 101, 102], function(errorCode) {
            dialogConfig[errorCode] = {
                title: Services.languageManager.getText(
                    Language.Keys.outOfMoney
                ),
                text: Services.languageManager.getText(Language.Keys.deposit),
                buttons: isHomeAvailable ? depositOrHomeButton : [{ type: "closeAndRevertSpin", primary: true }]
            };
        });

        Sys.each([0, 53, 56, 58], function(errorCode) {
            dialogConfig[errorCode] = {
                title: Services.languageManager.getText(Language.Keys.gameUnavailable) + " (" + errorCode + ")",
                buttons: isHomeAvailable ? [{ type: "casino", reason: Utils.CONSTANTS.REASON_CODES.TECHNICAL_ERROR }, reload] : [reload],
                fatal: true
            };
        });

        dialogConfig[70] = {
            title: Services.languageManager.getText(Language.Keys.accountUnavailable),
            buttons: isHomeAvailable ? [{ type: "casino" }, reload] : [reload],
            fatal: true
        };

        dialogConfig.generic = {
            title: Services.languageManager.getText(Language.Keys.error),
            text: Services.languageManager.getText(isHomeAvailable ? Language.Keys.returnToLobby : Language.Keys.reload),
            buttons: isHomeAvailable ? [{ type: "casino", reason: Utils.CONSTANTS.REASON_CODES.TECHNICAL_ERROR, primary: true }] : [reload],
            fatal: true,
            hideGame: true
        };

        dialogConfig.gameInactive = {
            title: Services.languageManager.getText(Language.Keys.gameUnavailable),
            text: Services.languageManager.getText(Language.Keys.lostConnectInactivity),
            buttons: isHomeAvailable ? [{ type: "casino", reason: Utils.CONSTANTS.REASON_CODES.TECHNICAL_ERROR }, reload] : [reload],
            fatal: true,
            hideGame: true
        };

        return dialogConfig;
    },

    /**
     * Gets dialog config from error code.
     *
     * @param {string} error The error code.
     * @returns {Object} Dialog config.
     */
    getDialogConfig: function(error) {
        var dialogConfigs = this.readData("dialogConfig"),
            dialogConfig;

        if (Sys.isDefined(dialogConfigs[error])) {
            dialogConfig = dialogConfigs[error];
        }
        else {
            dialogConfig = dialogConfigs.generic;
        }

        dialogConfig.errorCode = error;

        return dialogConfig;
    },

    /**
     * Set up a config for the out of money dialog. Overridden for desktop.
     *
     * @returns {{title: string, text: string, buttons: Object[], errorCode: number}} Config object for error.
     */
    setUpOutOfMoneyErrorConfig: function() {
        var title = Services.languageManager.getText(Language.Keys.outOfMoney),
            depositAvailable = this.readData("depositAvailable"),
            balance = Services.moneyManager.getBalanceCents(),
            minimumBet = Services.moneyManager.getMinimumBetCents(),
            isHomeAvailable = Sys.utils.isHomeAvailable(),
            text,
            buttons;

        // Check if the player can make a bet
        if (balance >= minimumBet) {
            // Check if the operator supports direct depositing
            if (depositAvailable && isHomeAvailable) {
                text = Services.languageManager.getText(Language.Keys.deposit);
                buttons = [{ type: "deposit" }, { type: "reduceBet", primary: true }];
            }
            else if (!depositAvailable && isHomeAvailable) {
                text = Services.languageManager.getText(Language.Keys.deposit);
                buttons = [{ type: "casino" }, { type: "reduceBet", primary: true }];
            }
            else {
                text = Services.languageManager.getText(Language.Keys.reduce);
                buttons = [{ type: "close", primary: true }];
            }
        }
        else {
            text = Services.languageManager.getText(Language.Keys.depositPlay);

            if (depositAvailable && isHomeAvailable) {
                buttons = [{ type: "deposit" }, { type: "close", primary: true }];
            }
            else if (!depositAvailable && isHomeAvailable) {
                buttons = [{ type: "casino" }, { type: "close", primary: true }];
            }
            else {
                buttons = [{ type: "close", primary: true }];
            }
        }

        return {
            title: title,
            text: text,
            buttons: buttons,
            errorCode: 100
        };
    }
};

Core.ErrorManagerModel = Sys.extend(Core.Model, Core.ErrorManagerModel, "Core.ErrorManagerModel");
